import { createAction } from 'redux-actions';

export const fetchApplication = createAction('FETCH_APPLICATION');
export const fetchApplicationSuccess = createAction('FETCH_APPLICATION_SUCCESS');
export const fetchApplicationFailure = createAction('FETCH_APPLICATION_FAILURE');

export const createApplication = createAction('CREATE_APPLICATION');
export const createApplicationSuccess = createAction('CREATE_APPLICATION_SUCCESS');
export const createApplicationFailure = createAction('CREATE_APPLICATION_FAILURE');

export const updateApplication = createAction('UPDATE_APPLICATION');
export const updateApplicationSuccess = createAction('UPDATE_APPLICATION_SUCCESS');
export const updateApplicationFailure = createAction('UPDATE_APPLICATION_FAILURE');

export const deleteApplication = createAction('DELETE_APPLICATION');
export const deleteApplicationSuccess = createAction('DELETE_APPLICATION_SUCCESS');
export const deleteApplicationFailure = createAction('DELETE_APPLICATION_FAILURE');

export function newApplication() {
	const data = {};

	return {
		type: fetchApplicationSuccess,
		payload: data
	};
}
